import { useTranslation } from 'react-i18next';
import { useDocumentMetadata } from '../hooks/useDocumentMetadata';
import { HeroSection } from '../components/home/HeroSection';
import { AboutSection } from '../components/home/AboutSection';
import { ServicesSection } from '../components/home/ServicesSection';
import { SegmentsSection } from '../components/home/SegmentsSection';
import { TechStackSection } from '../components/home/TechStackSection';
import { TeamSection } from '../components/home/TeamSection';
import { ContactSection } from '../components/home/ContactSection';
import { RailwayNavigation } from '../components/ui/RailwayNavigation';
import styles from './HomePage.module.css';

export const HomePage = () => {
  const { t } = useTranslation();
  
  useDocumentMetadata(
    "NexTrainE — Engineering What's Next",
    t('hero.subtitle')
  );

  return (
    <>
      <HeroSection />
      <div className={styles.stickyTrackWrapper}>
        <div className={styles.trackGutter}>
          <RailwayNavigation />
        </div>
        <AboutSection />
        <ServicesSection />
        <SegmentsSection />
        <TechStackSection />
        <TeamSection />
        <ContactSection />
      </div>
    </>
  );
};
